import React, { useEffect, useState } from "react";

const MeetTheTeam = () => {
    const [hoveredCard, setHoveredCard] = useState(null);
    const [isMobile, setIsMobile] = useState(
        typeof window !== "undefined" ? window.innerWidth <= 768 : false
    );

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    const containerStyle = {
        padding: isMobile ? "22px 14px 34px" : "36px 22px 48px",
        maxWidth: "980px",
        margin: "auto",
        fontFamily: "'Arial', sans-serif",
        lineHeight: "1.7",
        color: "#333",
    };

    const heroStyle = {
        background: "linear-gradient(135deg, #f6f9fc 0%, #eef3f7 100%)",
        border: "1px solid #e6ecf1",
        borderRadius: "16px",
        padding: isMobile ? "22px 14px" : "34px 24px",
        marginBottom: "28px",
        textAlign: "center",
    };

    const sectionStyle = {
        marginBottom: "28px",
    };

    const sectionHeadingStyle = {
        marginBottom: "8px",
        color: "#2c3e50",
        fontWeight: "bold",
        letterSpacing: "0.2px",
    };

    const founderCardStyle = {
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        flexWrap: "wrap",
        gap: isMobile ? "14px" : "24px",
        alignItems: "center",
        border: "1px solid #e8edf2",
        borderRadius: "16px",
        padding: isMobile ? "14px" : "20px",
        backgroundColor: "#ffffff",
        boxShadow: "0 10px 24px rgba(44, 62, 80, 0.06)",
    };

    const founderImageStyle = {
        width: isMobile ? "100%" : "240px",
        maxWidth: "100%",
        height: isMobile ? "260px" : "300px",
        objectFit: "cover",
        borderRadius: "14px",
        border: "1px solid #dde4eb",
    };

    const founderTextStyle = {
        flex: "1 1 340px",
        minWidth: isMobile ? "100%" : "250px",
    };

    const gridStyle = {
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(300px, 1fr))",
        gap: isMobile ? "12px" : "16px",
    };

    const cardRowStyle = {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: isMobile ? "14px" : "18px",
        minHeight: isMobile ? "0" : "108px",
    };

    const cardBodyStyle = {
        flex: "1 1 auto",
        minWidth: 0,
        textAlign: "left",
    };

    const avatarWrapStyle = {
        flexShrink: 0,
        width: isMobile ? "72px" : "88px",
        height: isMobile ? "72px" : "88px",
        borderRadius: "50%",
        overflow: "hidden",
        border: "2px solid #e3eaf1",
        boxShadow: "0 2px 8px rgba(44, 62, 80, 0.08)",
        backgroundColor: "#f4f7fa",
    };

    const avatarImgStyle = {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        objectPosition: "center top",
        display: "block",
    };

    const cardStyle = {
        backgroundColor: "#ffffff",
        border: "1px solid #e7edf3",
        borderRadius: "14px",
        padding: isMobile ? "14px 14px 14px 16px" : "16px 18px 16px 20px",
        boxShadow: "0 6px 16px rgba(44, 62, 80, 0.05)",
        transition: "transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease",
        cursor: "default",
    };

    const roleStyle = {
        margin: "6px 0 14px",
        color: "#5c6b77",
        fontSize: "15px",
    };

    const linkedInButtonStyle = {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        textDecoration: "none",
        color: "#0a66c2",
        fontWeight: 600,
        fontSize: isMobile ? "15px" : "14px",
        minHeight: "36px",
    };

    const teamMembers = [
        {
            name: "Ali Asjad",
            role: "Full Stack Developer",
            linkedin: "https://www.linkedin.com/in/ali-asjad-412515229/",
            photo: "/TeamPics/ali_developer.jpg",
        },
        {
            name: "Amtur",
            role: "UTSC Chapter Lead",
            linkedin: "https://www.linkedin.com/in/amtur-raqeeb/",
            photo: "/TeamPics/amtur_utscLead.jpeg",
        },
        {
            name: "Megan",
            role: "UTSG Chapter Lead",
            linkedin: "https://www.linkedin.com/in/megan-a-ali/",
            photo: "/TeamPics/megan_utsgLead.jpg",
        },
        {
            name: "Mariam",
            role: "UTSG Chapter Lead",
            linkedin: "https://www.linkedin.com/in/mariam-a-835442229/",
            photo: "/TeamPics/mariam_utsgLead.jpg",
        },
    ];

    const LinkedInIcon = () => (
        <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
        >
            <path d="M6.94 8.5A2.16 2.16 0 1 1 6.93 4.2a2.16 2.16 0 0 1 .01 4.31ZM4.92 20V9.9h4.05V20H4.92Zm6.38 0V9.9h3.89v1.38h.06c.54-1.02 1.86-2.1 3.83-2.1 4.09 0 4.84 2.69 4.84 6.18V20h-4.05v-4.1c0-.98-.02-2.24-1.36-2.24-1.36 0-1.57 1.06-1.57 2.17V20H11.3Z" />
        </svg>
    );

    return (
        <div style={containerStyle}>
            <section style={heroStyle}>
                <h1 style={{ margin: "0 0 8px", color: "#2c3e50", fontSize: isMobile ? "28px" : "36px" }}>
                    Meet Our Team
                </h1>
                <p style={{ margin: 0, maxWidth: "680px", marginInline: "auto", color: "#516171" }}>
                    We are building Rate My Courses to make course planning easier, smarter, and
                    more transparent for students across campuses.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2 style={sectionHeadingStyle}>Founder Spotlight</h2>
                <div style={founderCardStyle}>
                    <img
                        src="/TeamPics/aliya_ourfounder.png"
                        alt="Aliya Ali, Founder of Rate My Courses"
                        style={founderImageStyle}
                    />
                    <div style={founderTextStyle}>
                        <h3 style={{ margin: "0 0 8px", color: "#2c3e50" }}>Aliya Ali</h3>
                        <p style={{ margin: "0 0 12px", color: "#5c6b77", fontWeight: 600 }}>
                            Founder
                        </p>
                        <p style={{ margin: "0 0 14px" }}>
                            Aliya founded Rate My Courses to make course decisions less stressful
                            and more informed for students. Her vision is to build a trusted space
                            where students can learn from each other and choose courses with
                            confidence.
                        </p>
                        <a
                            href="https://www.linkedin.com/in/aliyaali-shaikha/"
                            aria-label="Aliya Ali LinkedIn profile"
                            style={linkedInButtonStyle}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <LinkedInIcon />
                            LinkedIn
                        </a>
                    </div>
                </div>
            </section>

            <section style={sectionStyle}>
                <h2 style={sectionHeadingStyle}>Our Leadership Team</h2>
                <div style={gridStyle}>
                    {teamMembers.map((member, index) => (
                        <article
                            key={member.name}
                            style={{
                                ...cardStyle,
                                transform: hoveredCard === index ? "translateY(-3px)" : "translateY(0)",
                                boxShadow:
                                    hoveredCard === index
                                        ? "0 12px 24px rgba(44, 62, 80, 0.12)"
                                        : cardStyle.boxShadow,
                                borderColor: hoveredCard === index ? "#d8e2ec" : "#e7edf3",
                            }}
                            onMouseEnter={() => setHoveredCard(index)}
                            onMouseLeave={() => setHoveredCard(null)}
                        >
                            <div style={cardRowStyle}>
                                <div style={cardBodyStyle}>
                                    <h3 style={{ margin: 0, color: "#2c3e50" }}>{member.name}</h3>
                                    <p style={{ ...roleStyle, margin: "6px 0 10px" }}>{member.role}</p>
                                    <a
                                        href={member.linkedin}
                                        aria-label={`${member.name} LinkedIn profile`}
                                        style={linkedInButtonStyle}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <LinkedInIcon />
                                        LinkedIn
                                    </a>
                                </div>
                                <div style={avatarWrapStyle} aria-hidden="true">
                                    <img
                                        src={member.photo}
                                        alt=""
                                        style={avatarImgStyle}
                                    />
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </section>

            <section style={sectionStyle}>
                <h2 style={sectionHeadingStyle}>Why We Built Rate My Courses</h2>
                <p style={{ margin: 0 }}>
                    We created this platform to help students access real course insights, plan
                    better semesters, and support one another through transparent, experience-based
                    feedback.
                </p>
            </section>
        </div>
    );
};

export default MeetTheTeam;
